import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(site)/the-app/UI.tsx");
